import {
  IConfiguration,
  TFeatureFlag,
  TFeatureFlagValues,
} from "models/configurations.models";

const getFeatureFlagValues = (
  featureFlagId: string,
  configurations: IConfiguration[],
): TFeatureFlagValues =>
  Object.fromEntries(
    configurations.map((config) => [
      config.tenantId,
      config.featureFlags.enabled.includes(featureFlagId),
    ]),
  );

export const getFeatureFlags = (
  configurations: IConfiguration[],
): TFeatureFlag[] =>
  configurations.at(0)?.featureFlags.available.map(({ flag, ...rest }) => ({
    id: flag,
    name: flag,
    ...rest,
    values: getFeatureFlagValues(flag, configurations),
  })) ?? [];
